import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.06795 0.137948L6.99429 6.06111L12.8577 0.197415C13.2573 -0.158516 13.6708 0.0539933 13.8361 0.232396C13.9421 0.361594 13.9968 0.525332 13.9897 0.692312C13.9826 0.859291 13.9142 1.0178 13.7976 1.13753L7.93334 7.00035L13.7976 12.8614C14.0582 13.08 14.0582 13.5086 13.8492 13.7482C13.6393 13.9869 13.2546 14.1251 12.8918 13.8418L6.99429 7.93959L1.0898 13.8444C0.830997 14.0761 0.404315 14.0289 0.193597 13.7989C-0.0179959 13.568 -0.0984362 13.1692 0.171738 12.8877L6.05524 7.00035L0.19622 1.13753C-0.0179961 0.901408 -0.0923159 0.469393 0.19622 0.197415C0.484755 -0.0745621 0.914935 -0.0369573 1.06795 0.137948Z",
		fill: "currentColor"
	})
});
export default SvgClose;
